var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCosmeticslittle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15.31 15.08",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: #5b5757;\n      }"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.62,0C4.9,2.39.23,7.43.23,7.43l-.23.24.24.23c2.22,2.16,4.59,4.51,7.29,6.97l.23.2.23-.2c2.72-2.42,5.03-4.83,7.1-6.86l.22-.22-.2-.24S10.77,2.38,8.07,0l-.45.51c1.31,1.15,3.05,3.03,4.47,4.61,1.41,1.58,2.49,2.87,2.5,2.87l.26-.22-.24-.24c-2.08,2.05-4.38,4.44-7.08,6.84l.23.25.23-.25c-2.68-2.44-5.04-4.8-7.27-6.95l-.24.24.25.23s1.17-1.26,2.67-2.81c1.5-1.55,3.34-3.4,4.68-4.57l-.45-.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.03,7.37h-.25c0,1.11-.45,2.11-1.17,2.83-.72.72-1.72,1.17-2.83,1.17s-2.1-.45-2.83-1.17c-.72-.72-1.17-1.72-1.17-2.83s.45-2.11,1.17-2.83c.73-.72,1.72-1.17,2.83-1.17s2.11.45,2.83,1.17c.73.73,1.17,1.72,1.17,2.83h.5c0-2.49-2.02-4.5-4.5-4.5S3.28,4.88,3.28,7.37s2.02,4.5,4.5,4.5,4.5-2.02,4.5-4.5h-.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCosmeticslittle);
export default __webpack_public_path__ + "static/media/cosmeticslittle.e56a8d0641cef7ec1bb58140ab2d86b0.svg";
export { ForwardRef as ReactComponent };